import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgModule, Output, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';
import { WRxBase } from '@wipo/w-angular/shared';


@Component({
    selector: 'w-input-badge',
    template: `
    <span *ngIf="!disabled && !counterBadge" class="b-icon--close" (click)="wClose.emit()"></span>
    <span [innerHTML]="text" [attr.title]="tip | async"></span>
    <span #free class="b-flex-grow" style="padding: 0"></span> 
  `, host: {
        class: "b-input__multi-select--badge b-flex-row",
        "[class.counter-badge]": 'counterBadge',
        "[class.single-digit]": 'isCounterBadgeSingleDigit',
        "[style.display]": 'counterBadge ? "inline-block" : null',
        "[style.max-width.px]": 'maxWidthBinding',
        "[style.cursor]": 'disabled?"default":""',
    },
    standalone: false
})
/*
@id w-input-badge
@name w-input-badge
@status release
@description badge used by multi-select and input-file as a separate component
*/
export class WInputBadgeComponent extends WRxBase implements AfterViewInit {
    @Input() counterBadge: boolean = false; // displays a "counter badge"
    @Input() maxWidth: number = 140; // maximum width in px
    @Input() text: string = ''; // label
    @Input() disabled: boolean = false; // badge disabled
    @Output() wClose = new EventEmitter<void>(); // emit event when clicked on (X)
    @ViewChild('free') free!: ElementRef<HTMLElement>;
    tip = new EventEmitter<string | null>(true);

    constructor(private el: ElementRef<HTMLElement>) { super(); }
    ngAfterViewInit(): void {
        this.showTooltip();
        this.runOnMutation(this.el.nativeElement, { childList: true, subtree: true, characterData: true }, () => {
            this.showTooltip();
        });
    }

    get maxWidthBinding(): number | null {
        return this.counterBadge ? null : this.maxWidth;
    }

    get isCounterBadgeSingleDigit() {
        /** allow enter also numbers (though probably it should be caught in linter) */
        const text = (typeof this.text === 'number' ? `${this.text}` : this.text).trim();
        return this.counterBadge && text.length === 1;
    }

    private showTooltip() {
        const larger = this.free?.nativeElement.clientWidth === 0;
        this.tip.emit(larger ? this.text : '');
    }
}

@NgModule({
    imports: [CommonModule],
    exports: [WInputBadgeComponent],
    declarations: [WInputBadgeComponent]
})
export class WInputBadgeModule { }
